export type ToastType = "success" | "error" | "info";

type ToastHandler = (message: string, type?: ToastType) => void;

let handler: ToastHandler | null = null;

export const ToastService = {
    register(showToast: ToastHandler) {
        handler = showToast;
    },

    unregister() {
        handler = null;
    },

    show(message: string, type: ToastType = "success") {
        handler?.(message, type);
    },

    success(message: string) {
        handler?.(message, "success");
    },

    error(message: string) {
        handler?.(message, "error");
    },

    info(message: string) {
        handler?.(message, "info");
    }
};